export default "__VITE_ASSET__BcWX6Qeo__"